import React from 'react';
import { NavLink } from 'react-router-dom';

import { MenuItem } from '../../types/header';
import { AccountPanel } from '../AccountPanel/AccountPanel';
import Logo from '../Logo';
import ActionsMenu from '../ActionsMenu';
import Section from '../Section';
import { useAuth } from '../../contexts/AuthContext';

import styles from './Header.module.scss';

export interface HeaderProps {
  userName?: string;
  menuItems: MenuItem[];
}

export function Header({ menuItems }: HeaderProps) {
  const { user } = useAuth();

  const getInitialsFromEmail = (email: string): string => {
    if (!email) return '';

    const username = email.split('@')[0];
    const parts = username.split(/[.\-_]/);

    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }

    return username.slice(0, 2).toUpperCase();
  };

  return (
    <Section className="header">
      <div className="container">
        <header className={styles.header}>
          <Logo className={styles.logo} />
          <nav className={styles.menu}>
            {menuItems.map(({ link, name }, index) => (
              <div className={styles.menuItem} key={index}>
                <NavLink
                  className={({ isActive }) => (!link.startsWith('#') && isActive ? 'active' : '')}
                  to={`/${link}`}
                  end
                >
                  {name}
                </NavLink>
              </div>
            ))}
          </nav>
          {user ? (
            <AccountPanel userName={user.email} userInitials={getInitialsFromEmail(user.email)} />
          ) : (
            <ActionsMenu />
          )}
        </header>
      </div>
    </Section>
  );
}
